import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from "app/brightserve/authentication.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authenticationService: AuthenticationService,  private router: Router) { }

    canActivate() {
        if (this.authenticationService.isAuthorized())
            return true;

        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/auth-guard.ts